// admin-panel/src/components/Navbar.jsx (UPDATED)
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

// --- SVG Icons for the Navbar ---
const MenuIcon = () => (<svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>);
const ChevronDownIcon = () => (<svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>);


const Navbar = ({ onToggleSidebar }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userRole, setUserRole] = useState('Loading...'); // New state for dynamic role
  const navigate = useNavigate();

  // --- EFFECT TO READ ROLE FROM LOCAL STORAGE ---
  useEffect(() => {
    const role = localStorage.getItem('admin_role');
    if (role) {
      setUserRole(role);
    } else {
      setUserRole('Guest');
    }
  }, []);
  // ---------------------------------------------

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_role'); // Clear the role on logout
    navigate('/login');
  };

  // Determine display name and role text
  const displayName = userRole === 'Admin' ? 'Admin' :
    userRole === 'Counselor' ? 'Counselor' :
      'User';
  const roleText = userRole === 'Admin' ? 'Administrator' :
    userRole === 'Counselor' ? 'Sales Counselor' :
      'Guest';

  return (
    <header className="dashboard-navbar">
      <div className="navbar-left">
        <button onClick={onToggleSidebar} className="sidebar-toggle-btn">
          <MenuIcon />
        </button>
        <Link to="/" onClick={() => window.scrollTo(0, 0)}>
          <img src="/logo.png" alt="Logo" className="navbar-logo" />
        </Link>
      </div>

      <div className="navbar-right">
        <div className="profile-section" onClick={() => setDropdownOpen(!dropdownOpen)}>

          <div className="user-info">
            {/* --- DYNAMICALLY DISPLAY ROLE --- */}
            <span className="user-name">{displayName}</span>
            <span className="user-role">{roleText}</span>
            {/* ------------------------------- */}
          </div>
          <ChevronDownIcon />

          {dropdownOpen && (
            <div className="profile-dropdown">
              <button onClick={handleLogout} className="dropdown-item">Logout</button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;